import moment from 'moment';
import { WritingInterval } from '../../../Models';

export class WritingIntervalsTracker {
  private writingIntervals: WritingInterval[];
  private currentWritingInterval?: WritingInterval;
  private intervalTimeoutId?: any;

  constructor() {
    this.writingIntervals = [];
  }

  public start(existingIntervals: WritingInterval[]) {
    this.stop();

    this.writingIntervals = existingIntervals.slice();
    this.intervalTimeoutId = setInterval(this.updateActivityIntervals, 5000);
  }

  public stop() {
    clearInterval(this.intervalTimeoutId);
    this.intervalTimeoutId = null;
  }

  public isActive(): boolean {
    return Boolean(this.intervalTimeoutId);
  }

  public updateActivityTime = (time: Date) => {
    if (!this.currentWritingInterval) {
      this.currentWritingInterval = {
        start: time,
        finish: time,
      };
    }

    this.currentWritingInterval.finish = time;
  };

  public getWritingIntervals(): WritingInterval[] {
    if (this.currentWritingInterval) {
      return this.writingIntervals.concat({ ...this.currentWritingInterval });
    } else {
      return this.writingIntervals;
    }
  }

  private updateActivityIntervals = () => {
    if (this.currentWritingInterval && moment().diff(moment(this.currentWritingInterval.finish), 'seconds') > 30) {
      this.writingIntervals.push(this.currentWritingInterval);
      this.currentWritingInterval = undefined;
    }
  };
}



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageEditor/WritingIntervalsTracker.ts